import { type ComputedRef, computed } from 'vue'

import { type Flags, evaluateFlags } from '@/helpers/configCat'

import { useIdentityStore } from '@/stores/identity'

/**
 * Reactive ConfigCat flags. Automatically re-evaluates when identity changes (login, logout, session expiry).
 */
export function useFlags(): ComputedRef<Flags> {
  const store = useIdentityStore()
  const flags = computed((): Flags => {
    const identityId = store.isLoggedIn && store.identityId
    const email = store.email ?? undefined
    const identity = identityId ? { id: identityId, email } : undefined
    return evaluateFlags(identity)
  })
  return flags
}
